import React from "react";
import "./index.css";
import {
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridRowId,
} from "@mui/x-data-grid";
import { TrapType } from "../../../types";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from "@mui/material";

interface Props {
  trapTypes?: TrapType[];
  handleOpen: () => void;
  handleEdit: (arg0: TrapType) => void;
  loading: boolean;
}

const TrapTypesTable: React.FC<Props> = ({
  trapTypes,
  handleOpen,
  handleEdit,
  loading,
}) => {
  const handleDeleteClick = (id: GridRowId) => () => {
    // setRows(rows.filter((row) => row.id !== id));
  };

  const handleEditClick = (id: GridRowId) => () => {
    const item = trapTypes?.filter((row) => row.id === id)[0];
    if (item) {
      handleEdit(item);
    }
  };

  const columns: GridColDef[] = [
    { field: "displayName", headerName: "Display Name", width: 150 },
    { field: "trapType", headerName: "Collection Method", width: 150 },
    { field: "attractant", headerName: "Attractant", width: 150 },
    { field: "description", headerName: "Description", flex: 1 },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const handleCreateClick = (): void => {
    handleOpen();
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="table-collection">
        <DataGrid
          rows={trapTypes}
          columns={columns}
          sx={{ "--DataGrid-overlayHeight": "100%" }}
          loading={loading}
        />
      </div>
      <div className="btn-create-new-trap-site-wrapper">
        <Button
          variant="contained"
          href="#contained-buttons"
          onClick={handleCreateClick}
        >
          Create New Trap Site
        </Button>
      </div>
    </div>
  );
};

export default TrapTypesTable;
